import { cn } from '@/lib/utils';
import { formatStorybookMxn, formatStorybookUsd } from '@/lib/storybook-utils';

interface StorybookPriceTagProps {
  /** MXN centavos — what Stripe charges. */
  cents: number;
  /** USD display anchor — never charged. */
  usdCents: number;
  size?: 'md' | 'lg';
  className?: string;
  testId?: string;
}

/**
 * Same presentation as the Pricing page's pack cards: MXN (what is charged)
 * and the USD anchor side by side at the same weight, each with its code, so
 * nobody has to guess which currency a bare "$179" is.
 */
export function StorybookPriceTag({ cents, usdCents, size = 'lg', className, testId }: StorybookPriceTagProps) {
  const amount = size === 'lg' ? 'text-3xl' : 'text-2xl';
  return (
    <div className={cn('flex flex-wrap items-baseline gap-x-3 gap-y-1', className)} data-testid={testId}>
      <span className="whitespace-nowrap">
        <span className={cn(amount, 'font-extrabold')}>{formatStorybookMxn(cents)}</span>
        <span className="ml-1 text-sm font-bold text-muted-foreground">MXN</span>
      </span>
      <span className="whitespace-nowrap">
        <span className={cn(amount, 'font-extrabold')}>{formatStorybookUsd(usdCents)}</span>
        <span className="ml-1 text-sm font-bold text-muted-foreground">USD</span>
      </span>
    </div>
  );
}
